import React from "react";
import shareDevices from "images/shareDevices.png";

const HlpShareDevices = () => {
  return (
    <>
      <h1>Share Audio and Video</h1>
      <img src={shareDevices} alt="share devices" />
    </>
  );
};

export default HlpShareDevices;
